import React from 'react';
import { DeviceComponent, DeviceComponentProps } from './BaseDevice';

const EmptyComponent: DeviceComponent = (props: DeviceComponentProps) => {
  return (<></>);
};

export default EmptyComponent;